export default __webpack_public_path__ + "static/media/thank_you.851b8da3.png";